import React, { useRef, useState } from 'react';

const MegaMenuItem = ({ label, children }) => {
  const [open, setOpen] = useState(false);
  const closeTimer = useRef(null);

  const handleEnter = () => {
    clearTimeout(closeTimer.current);
    setOpen(true);
  };

  const handleLeave = () => {
    closeTimer.current = setTimeout(() => setOpen(false), 120);
  };

  return (
    <li
      className={"nav-item gf-mega-item" + (open ? " gf-mega-active" : "")}
      onMouseEnter={handleEnter}
      onMouseLeave={handleLeave}
    >
      <button type="button" className="gf-mega-trigger">
        {label}
        <svg width="10" height="6" viewBox="0 0 10 6" fill="none" className="gf-mega-chevron">
          <path d="M1 1L5 5L9 1" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
        </svg>
      </button>
      <div className="gf-mega-wrap">
        <div className="gf-mega-panel">{children}</div>
      </div>
    </li>
  );
};

export default MegaMenuItem;
